import { render, staticRenderFns } from "./vehiclesSelect.vue?vue&type=template&id=5f02820c&"
import script from "./vehiclesSelect.vue?vue&type=script&lang=js&"
export * from "./vehiclesSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports